import type { Callback, RequestOptions } from 'mixpanel-browser';
import { MIXPANEL_LOG_PREFIXES } from './constants';
import type {
  MixpanelCallback,
  MixpanelConfig,
  MixpanelProperties,
  MockMixpanelInterface,
} from './types';

/**
 * Mock Mixpanel for local testing
 * Logs all Mixpanel calls to console with proper type signatures
 */
export const mockMixpanel: MockMixpanelInterface = {
  init: (token: string, config: MixpanelConfig) => {
    console.log(MIXPANEL_LOG_PREFIXES.INIT, { token, config });
  },

  identify: (userId: string) => {
    console.log(MIXPANEL_LOG_PREFIXES.IDENTIFY, userId);
  },

  track: (
    event: string,
    properties?: MixpanelProperties,
    optionsOrCallback?: RequestOptions | Callback,
    callback?: Callback,
  ) => {
    console.log(MIXPANEL_LOG_PREFIXES.TRACK, { event, properties });

    // Handle callback based on argument type
    if (typeof optionsOrCallback === 'function') {
      optionsOrCallback(1);
    } else if (callback) {
      callback(1);
    }
  },

  people: {
    set: (properties: MixpanelProperties, callback?: MixpanelCallback) => {
      console.log(MIXPANEL_LOG_PREFIXES.PEOPLE_SET, properties);
      callback?.(1);
    },

    set_once: (properties: MixpanelProperties, callback?: MixpanelCallback) => {
      console.log(MIXPANEL_LOG_PREFIXES.PEOPLE_SET_ONCE, properties);
      callback?.(1);
    },
  },

  register: (properties: MixpanelProperties) => {
    console.log(MIXPANEL_LOG_PREFIXES.REGISTER, properties);
  },

  alias: (alias: string, original?: string) => {
    console.log(MIXPANEL_LOG_PREFIXES.ALIAS, { alias, original });
  },

  reset: () => {
    console.log(MIXPANEL_LOG_PREFIXES.RESET);
  },
};
